
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/webhook",
      function () {
        return require("private-next-pages/docs/webhook.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/webhook"])
      });
    }
  